/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */
// tslint:disable:no-magic-numbers no-submodule-imports
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { ConfigurationHttpRequestInterceptor, MaintenanceHttpResponseInterceptor } from '@gh/common-shared';
import { API_BASE_URL } from '@gh/config';
import { AUTH_HTTP_INTERCEPTOR } from '@gh/core-auth';
import { API_BASE_URL as API_BASE_URL_TOKEN } from '@gh/core-data';
import { MessageHttpErrorInterceptor, MessageHttpResponseInterceptor } from '@gh/core-messages';
import * as i0 from "@angular/core";
var SupplierHttpClientConfigModule = /** @class */ (function () {
    function SupplierHttpClientConfigModule() {
    }
    SupplierHttpClientConfigModule.ɵmod = i0.ɵɵdefineNgModule({ type: SupplierHttpClientConfigModule });
    SupplierHttpClientConfigModule.ɵinj = i0.ɵɵdefineInjector({ factory: function SupplierHttpClientConfigModule_Factory(t) { return new (t || SupplierHttpClientConfigModule)(); }, providers: [
            {
                provide: API_BASE_URL_TOKEN,
                useValue: API_BASE_URL,
            },
            { provide: HTTP_INTERCEPTORS, useExisting: ConfigurationHttpRequestInterceptor, multi: true },
            { provide: HTTP_INTERCEPTORS, useExisting: AUTH_HTTP_INTERCEPTOR, multi: true },
            { provide: HTTP_INTERCEPTORS, useExisting: MessageHttpResponseInterceptor, multi: true },
            { provide: HTTP_INTERCEPTORS, useExisting: MessageHttpErrorInterceptor, multi: true },
            // { provide: HTTP_INTERCEPTORS, useExisting: LogoutHttpErrorInterceptor, multi: true },
            { provide: HTTP_INTERCEPTORS, useExisting: MaintenanceHttpResponseInterceptor, multi: true },
        ], imports: [[HttpClientModule]] });
    return SupplierHttpClientConfigModule;
}());
export { SupplierHttpClientConfigModule };
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(SupplierHttpClientConfigModule, { imports: [HttpClientModule] }); })();
/*@__PURE__*/ (function () { i0.ɵsetClassMetadata(SupplierHttpClientConfigModule, [{
        type: NgModule,
        args: [{
                imports: [HttpClientModule],
                providers: [
                    {
                        provide: API_BASE_URL_TOKEN,
                        useValue: API_BASE_URL,
                    },
                    { provide: HTTP_INTERCEPTORS, useExisting: ConfigurationHttpRequestInterceptor, multi: true },
                    { provide: HTTP_INTERCEPTORS, useExisting: AUTH_HTTP_INTERCEPTOR, multi: true },
                    { provide: HTTP_INTERCEPTORS, useExisting: MessageHttpResponseInterceptor, multi: true },
                    { provide: HTTP_INTERCEPTORS, useExisting: MessageHttpErrorInterceptor, multi: true },
                    // { provide: HTTP_INTERCEPTORS, useExisting: LogoutHttpErrorInterceptor, multi: true },
                    { provide: HTTP_INTERCEPTORS, useExisting: MaintenanceHttpResponseInterceptor, multi: true },
                ],
                exports: [],
            }]
    }], null, null); })();
